import styled from '@emotion/styled'

import type { FC } from 'react'

import FeatureBoxBase, * as FeatureBox from '@segment/matcha/components/FeatureBox'
import ColumnTrack from '@segment/matcha/components/ColumnTrack'
import { CheckIcon } from '@segment/matcha/components/Icons/Brandbook'
import IconWrapper from '@segment/matcha/components/IconWrapper'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

export interface RequirementListProps {
  requirements: string[]
}

const copy = {
  heading: `What do you need?`,
}

const RequirementList: FC<RequirementListProps> = ({ requirements }) => {
  return (
    <CopyTextBase>
      <CopyText.Heading tag="h2" variant="h5">
        {copy.heading}
      </CopyText.Heading>
      <ColumnTrack tag="ul" columns={1} gap="small">
        {requirements.map((requirement) => (
          <StyledFeatureBoxBase key={requirement} tag="li" alignment="left" headerPosition="left">
            <FeatureBox.Header>
              <IconWrapper variant="circle" elevation={1}>
                <CheckIcon />
              </IconWrapper>
            </FeatureBox.Header>
            <FeatureBox.Body>
              <FeatureBox.Text>{requirement}</FeatureBox.Text>
            </FeatureBox.Body>
          </StyledFeatureBoxBase>
        ))}
      </ColumnTrack>
    </CopyTextBase>
  )
}

const StyledFeatureBoxBase = styled(FeatureBoxBase)`
  align-items: center;
`

export default RequirementList
